export default "__VITE_ASSET__D_2XqMx8__";